import { Paper } from "@mui/material";
import Stack from "atoms/Stack";
import { FONT_FAMILY_LEAGUE_GOTHIC } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import React from "react";
import { useWindowSize } from "react-use-size";

import PageTitle from "./PageTitle";

export default function UnauthorisedPage({ currentUser }) {
  const windowSize = useWindowSize();
  return (
    <div
      style={{
        height: windowSize.height - 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <PageTitle title="Game Not Found" />
      <Paper
        style={{
          padding: SPACING,
        }}
      >
        <h1
          style={{
            textTransform: "uppercase",
            fontFamily: FONT_FAMILY_LEAGUE_GOTHIC,
            fontSize: 24,
            lineHeight: 1.5,
            margin: 0,
          }}
        >
          Game Not Found
        </h1>
        <Stack>
          <div>
            <p>Sorry, we couldn’t find that game. You’re signed in as {currentUser.email}.</p>
            <p>This account doesn’t have access. Log out and sign in with the email that received the game link.</p>
          </div>
        </Stack>
      </Paper>
    </div>
  );
}
